import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 6EB52FC2-32D9-427D-80DE-32C60C8F78AD
 * name table-chair
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/table-chair.svg
 * tags
 * - Home Automation 
 */
export const TableChairIcon = createSvgIcon(<><path d="M12 22H6A2 2 0 0 1 8 20V8H2V5H16V8H10V20A2 2 0 0 1 12 22M22 2V22H20V15H15V22H13V14A2 2 0 0 1 15 12H20V2Z" /></>, 'TableChairIcon');
export default TableChairIcon